import { render, staticRenderFns } from "./IconUserClock.vue?vue&type=template&id=9586a200&scoped=true&"
import script from "./IconUserClock.vue?vue&type=script&lang=ts&"
export * from "./IconUserClock.vue?vue&type=script&lang=ts&"
import style0 from "./IconUserClock.vue?vue&type=style&index=0&id=9586a200&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9586a200",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
